export const ALL_OPTION = [
  {
    value: "ALL",
    label: "All",
  },
];
